import { render, staticRenderFns } from "./MobileNavigationCranialSymposium.vue?vue&type=template&id=56351ce4&"
import script from "./MobileNavigationCranialSymposium.vue?vue&type=script&lang=js&"
export * from "./MobileNavigationCranialSymposium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports